import React, {Component} from 'react';
import './Actualite.css';
import photoActualite from '../../assets/photoActualite.jpg';

class Actualite extends Component {

    goToArticle(article) {
        window.open(article);
    }

    render() {
        return (

            <div id="actualites" className="row home-block">

                <div>
                    <h2 className="title">News</h2>

                    <div className="row actualite" onClick={() => this.goToArticle('https://drive.google.com/file/d/1iFenBbSpZhfjR-uAnAxqgH126rB8yNpt/view?usp=sharing')}>
                        <div className="col-md-3 col-xs-12">
                            <img id="photoActualite" src={photoActualite} alt="photoActualite" />
                        </div>

                        <div className="col-md-9 col-xs-12">
                          <p>We are recruiting for a PR position for September 2026. The job offer is available here.</p>
                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export default Actualite;




// WEBPACK FOOTER //
// ./src/Components/Actualite/Actualite.js